import React from "react";
import { CHECK_TYPES } from "../../DatasetCheckScreen.constants";
import { Box, Grid } from "@mui/material";
import { CheckItem } from "../CheckItem";
import { gaClickCallback } from "helpers/common";

export const CheckList = ({ checkState, setShowDetails }) => {
  return (
    <Grid container gap="48px" sx={{ flexDirection: "row", justifyContent: "center", flexWrap: "nowrap" }}>
      {CHECK_TYPES.map(({ label, description, name }, index) => (
        <Box width="33.3%" key={index}>
          <CheckItem
            {...{
              label,
              description,
              score: checkState[name].score,
              loading: checkState[name].loading,
              onClick: () =>
                gaClickCallback({
                  label: `inspect btn ${label}`,
                  callback: () => setShowDetails(name),
                }),
            }}
          />
        </Box>
      ))}
    </Grid>
  );
};
